import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ActionPlate from '../ActionPlate';
import ReasonView from '../ReasonView';

const CallsPicker = (props) => {
	const { links = [], calls = [], onChange } = props;
	return (
		<Stack spacing={2}>
			{links.length > 0 && (
				<Stack
					divider={
						<Typography sx={{ mx: 0.25 }} color="secondary">
							·
						</Typography>
					}
					direction="row"
					alignItems="center"
				>
					{links.map((link) => {
						if (link.active) {
							return (
								<Typography
									variant="body2"
									color="secondary"
									fontSize="0.8125rem"
									sx={{ p: 0.5 }}
									key={link.id}
								>
									{link.label}
								</Typography>
							);
						}
						return (
							<Button size="small" sx={{ p: 0.5 }} key={link.id}>
								{link.label}
							</Button>
						);
					})}
				</Stack>
			)}
			{calls.length > 0 && (
				<Stack spacing={1}>
					{calls.map((call) => {
						return (
							<ActionPlate
								isGrey
								onChange={onChange}
								key={call.id}
								{...call.plate}
							>
								{call.reason && <ReasonView {...call.reason} />}
							</ActionPlate>
						);
					})}
				</Stack>
			)}
		</Stack>
	);
};

CallsPicker.propTypes = {
	links: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
			label: PropTypes.string,
		}),
	),
	calls: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		}),
	),
	onChange: PropTypes.func,
};

export default CallsPicker;
